@if (maintenanceMode) {
<div class="maintenance-page">
  <div>
    <img src="assets/logo.svg" alt="ZGRANE GRONO Logo" style="height:90px;vertical-align:middle;" />
  </div>
  @if (!isCardRoute) {
  <div class="maintenance-card" role="alert" aria-live="polite">
    <p class="maintenance-subtitle">Prace serwisowe</p>
    <p class="maintenance-message">{{ maintenanceMessage }}</p>
    @if (maintenancePlanningTime) {
    <div class="maintenance-time">
      @if (maintenancePlanningTime?.start) {
      <div>Rozpoczęcie prac serwisowych: {{ $safeNavigationMigration(maintenancePlanningTime?.start) |
        date:'yyyy-MM-dd HH:mm' }}</div>
      }
      @if (maintenancePlanningTime?.end) {
      <div>Planowane zakończenie prac: {{ $safeNavigationMigration(maintenancePlanningTime?.end) |
        date:'yyyy-MM-dd HH:mm' }}</div>
      }
    </div>
    }
    @if (showMaintenanceRefresh) {
    <a class="maintenance-refresh" (click)="refreshPage()" aria-label="Odśwież stronę" role="button">
      <mat-icon aria-hidden="true">refresh</mat-icon>
      Odśwież stronę
    </a>
    }
    <a class="maintenance-qr-link" routerLink="/karta" aria-label="Otwórz kartę z kodem QR">
      <mat-icon aria-hidden="true">qr_code_2</mat-icon>
      Otwórz kartę QR
    </a>
  </div>
  }
  @if (isCardRoute) {
  <div class="maintenance-qr-container">
    <div class="center-items" aria-live="polite">
      <div>{{ maintenanceMessage }}</div>
      @if (maintenancePlanningTime) {
      <div class="maintenance-time">
        @if (maintenancePlanningTime?.start) {
        <div>Rozpoczęcie prac serwisowych: {{ $safeNavigationMigration(maintenancePlanningTime?.start) |
          date:'yyyy-MM-dd HH:mm' }}</div>
        }
        @if (maintenancePlanningTime?.end) {
        <div>Planowane zakończenie prac: {{ $safeNavigationMigration(maintenancePlanningTime?.end) |
          date:'yyyy-MM-dd HH:mm' }}</div>
        }
      </div>
      }
      <div>
        @if (true) {
        <a class="maintenance-refresh" (click)="refreshPage()" aria-label="Odśwież stronę" role="button">
          <mat-icon aria-hidden="true">refresh</mat-icon>
          Odśwież serwis
        </a>
        }
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
  }
</div>
} @else {
<!-- Splash Screen -->
@if (showSplashScreen) {
<app-splash-screen #splashScreen (splashComplete)="onSplashComplete()" [isLoadingData]="isLoadingData"
  [loadingProgress]="loadingProgress">
</app-splash-screen>
}
<!-- Main App Content -->
@if (!showSplashScreen) {
<mat-sidenav-container class="app-container">
  <mat-sidenav #drawer class="app-sidenav" mode="over">
    <mat-nav-list>
      <div class="mobile-menu-holder">
        @if (isLoggedIn) {
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem;" (click)="logout(); drawer.close()">
          Wyloguj
        </a>
        }
        @if (isLoggedIn) {
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem;" routerLink="/dashboard"
          (click)="drawer.close()">Panel użytkowanika</a>
        }
        @if (!isLoggedIn) {
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem;" routerLink="/logowanie"
          (click)="drawer.close()">Logowanie</a>
        }
        @if (isLoggedIn) {
        <a class="menu-item" [routerLink]="['/karta']" style="text-decoration:none; color:inherit; font-size: 0.8rem;"
          (click)="drawer.close()">
          Twoja karta
        </a>
        }
        @if (!isLoggedIn) {
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem;" routerLink="/rejestracja"
          (click)="drawer.close()">Rejestracja</a>
        }

        <hr style="border: 1px solid silver; margin: 8px 0;" />
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem; border-radius: 0;"
          routerLink="/wiadomosci" (click)="drawer.close()">Aktualności</a>
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem; border-radius: 0;"
          routerLink="/oferty" (click)="drawer.close()">Oferty</a>
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem; border-radius: 0;"
          routerLink="/partnerzy" (click)="drawer.close()">Partnerzy</a>
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem; border-radius: 0;"
          routerLink="/kontakt" (click)="drawer.close()">Kontakt</a>
        <hr style="border: 1px solid silver; margin: 8px 0;" />
        <a class="menu-item" [routerLink]="['/tresc', 'Regulamin']"
          style="cursor: pointer !important; font-size: 0.8rem;" (click)="drawer.close()">
          Regulamin
        </a>
        <a class="menu-item" [routerLink]="['/tresc', 'Polityka_prywatnosci']"
          style="cursor: pointer !important; font-size: 0.8rem;" (click)="drawer.close()">
          Polityka prywatności
        </a>
        <a class="menu-item" [routerLink]="['/informacje_o_karcie']"
          style="cursor: pointer !important; font-size: 0.8rem;" (click)="drawer.close()">
          O ZGranym Gronie
        </a>
        <a class="menu-item" [routerLink]="['/zostan-naszym-partnerem']"
          style="cursor: pointer !important; font-size: 0.8rem;" (click)="drawer.close()">
          Zostań naszym Partnerem
        </a>
        @if (isLoggedIn) {
        <a class="menu-item" [routerLink]="['/skanowanie']"
          style="text-decoration:none; color:inherit; font-size: 0.8rem;" (click)="drawer.close()">
          Skanowanie
        </a>
        }
        <hr style="border: 1px solid silver; margin: 8px 0;" />
        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem;"
          (click)="drawer.close(); showAppInfo()">
          O aplikacji
        </a>

        <a class="menu-item" style="cursor: pointer !important; font-size: 0.8rem;"
          (click)="drawer.close(); toggleWcagMode()">
          Tryb WCAG - Wysoki kontrast, duże czcionki
        </a>

      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="header-dolder" color="primary">
      <div class="header-mobile-menu-holder">
        <div class="hamburger-menu">
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
          </div>
        <span class="logo">
          <a routerLink="/" style="display:inline-block;"><img src="assets/logo.svg" alt="ZGRANE GRONO Logo"
              style="height:65px;vertical-align:middle;" /></a>
        </span>
        <span class="spacer"></span>
        <!--
          <button mat-icon-button (click)="toggleTheme()">
            <mat-icon>{{ themeService.getCurrentTheme() === 'light' ? 'dark_mode' : 'light_mode' }}</mat-icon>
          </button>
          -->
        <div class="header-mobile-menu-holder--right-side">
          <button mat-icon-button aria-label="Szukaj" (click)="goTo('/szukaj')" class="search-icon">
            <mat-icon>search</mat-icon>
          </button>
          @if (isLoggedIn) {
          <button mat-icon-button [routerLink]="['/dashboard']" aria-label="Ustawienia">
            <mat-icon>settings</mat-icon>
          </button>
          }

          @if (!isLoggedIn) {
          <button mat-icon-button [routerLink]="['/logowanie']" aria-label="Logowanie">
            <mat-icon>person</mat-icon>
          </button>
          }
        </div>
      </div>
    </mat-toolbar>
    <div class="layout-container">
      @if (maintenancePlanning) {
      <div class="maintenance-planning-banner" role="status" aria-live="polite">
        <mat-icon aria-hidden="true">info</mat-icon>
        <div class="maintenance-planning-text">
          <div>Zaplanowane prace serwisowe w aplikacji.</div>
          @if (maintenancePlanningTime?.start || maintenancePlanningTime?.end) {
          <div>
            @if (maintenancePlanningTime?.start) {
            <span>Start:
              {{ $safeNavigationMigration(maintenancePlanningTime?.start) | date:'yyyy-MM-dd
              HH:mm' }}
            </span>
            }
            @if (maintenancePlanningTime?.start && maintenancePlanningTime?.end) {
            <span> • </span>
            }
            @if (maintenancePlanningTime?.end) {
            <span>Koniec: {{ $safeNavigationMigration(maintenancePlanningTime?.end) | date:'yyyy-MM-dd
              HH:mm' }}</span>
            }
          </div>
          }
        </div>
      </div>
      }
      <div class="app-title">
        <div class="app-title__name"></div>
        <div class="app-title__description"></div>
      </div>
      <div class="app-content">
        <app-loader></app-loader>
        <router-outlet></router-outlet>
      </div>
    </div>
    @if (showGoBack) {
    <button class="go-back-btn" mat-fab aria-label="Wróć" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    }
    @if (showGoTop) {
    <button class="go-top-btn" mat-fab color="accent" aria-label="Idź na górę" (click)="scrollToTop()">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
}
<!-- Fixed Footer -->
@if (!showSplashScreen) {
<mat-toolbar color="primary" class="footer-toolbar">
  <button mat-icon-button class="footer-link" routerLink="/" aria-label="Home">
    <div class="footer-icon-wrapper">
      <mat-icon>home</mat-icon>
      <span class="footer-label">Home</span>
    </div>
  </button>
  <button mat-icon-button class="footer-link" routerLink="/oferty" aria-label="Oferty">
    <div class="footer-icon-wrapper">
      <mat-icon>restaurant</mat-icon>
      <span class="footer-label">Oferty</span>
    </div>
  </button>
  <button mat-icon-button class="footer-link" routerLink="/wiadomosci" aria-label="Aktualności">
    <div class="footer-icon-wrapper">
      <mat-icon>article</mat-icon>
      <span class="footer-label">Aktualności</span>
    </div>
  </button>
  <button mat-icon-button class="footer-link" routerLink="/karta" aria-label="Twoja karta">
    <div class="footer-icon-wrapper">
      <mat-icon>qr_code_2</mat-icon>
      <span class="footer-label">Karta</span>
    </div>
  </button>
</mat-toolbar>
}
}